import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { useBillingView } from '@web/account/billing/BillingViewContext/BillingViewContext';

export const useMissingBillingAddressTopTip = (isErrorTip: boolean) => {
  const theme = useTheme();

  const tipColors = useMemo(
    () => ({
      background: isErrorTip ? theme.colors.dangerLight : theme.colors.information,
      text: isErrorTip ? theme.colors.danger : theme.colors.white,
    }),
    [isErrorTip, theme]
  );

  const { isBillingInformationEditMode, setIsBillingInformationEditMode, scrollToBillingInfoEdit } =
    useBillingView();
  const onClick = () => {
    if (isBillingInformationEditMode) {
      scrollToBillingInfoEdit();
      return;
    }

    setIsBillingInformationEditMode(true);
  };

  return { tipColors, onClick };
};
